<div class="section" *ngIf="form">
    <form fxLayout="column" [formGroup]="form">
        <div *ngIf="jeAdresaZaOJ">
            <section class="example-section" style="margin-bottom: 1%;">
                <mat-checkbox class="example-margin" color="primary" formControlName="adresaNadredjenogOrgana"
                    (change)="postaviAdresuNadleznogOrgana($event.checked)">
                    {{
                    translatePrefix + "adresaNadredjenogOrgana" | translate
                    }}</mat-checkbox>
            </section>
        </div>
        <div fxLayout="row" fxLayoutGap="10px">
            <mat-form-field fxFlex="25">
                <input type="text" placeholder="{{translatePrefix + 'drzava' | translate}}" matInput
                    formControlName="drzava" [matAutocomplete]="autoDrzava" (keyup)="_filterDrzave()">
                <mat-error *ngIf="drzava.invalid" class="alert">
                    <span *ngIf="drzava.errors['invalidAutocompleteValue']">
                        {{translatePrefix + "nijeIzabranaDrzava" | translate}}
                    </span>
                </mat-error>
                <mat-autocomplete #autoDrzava="matAutocomplete">
                    <mat-option *ngFor="let drzava of filtriraneDrzave" [value]="drzava.cyrillicName"
                        (click)="setDrzavu(drzava)" class="autocomplete-mat-opetion">
                        {{drzava.cyrillicName}}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
            <mat-form-field fxFlex="50">
                <input matInput type="text" formControlName="tekstualnaAdresa"
                    placeholder="{{ translatePrefix + 'adresa' | translate }}" />
                <mat-error *ngIf="tekstualnaAdresa.invalid" class="alert">
                    <span *ngIf="tekstualnaAdresa.errors['required']">
                        {{translatePrefix + "obaveznoPolje"| translate: {
                        attributName: translatePrefix + "adresa" | translate} }}
                    </span>
                </mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="25">
                <input type="text" placeholder="{{
                    translatePrefix + 'opstina' | translate
                  }}" matInput formControlName="opstina" [matAutocomplete]="autoOpstina" (keyup)="_filterOpstine()">
                <mat-autocomplete #autoOpstina="matAutocomplete">
                    <mat-option *ngFor="let opstina of filtriraneOpstine" [value]="opstina.nazivCirilica"
                        (click)="setOpstinu(opstina)" class="autocomplete-mat-opetion">
                        {{opstina.nazivCirilica}}
                    </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="opstina.invalid" class="alert">
                    <span *ngIf="opstina.errors['required']">
                        {{translatePrefix + "obaveznoPolje"| translate: {
                        attributName: translatePrefix + "opstina" | translate} }}
                    </span>
                    <span *ngIf="opstina.errors['invalidAutocompleteValue']">
                        {{translatePrefix + "nijeIzabranaOpstina" | translate}}
                    </span>
                </mat-error>
            </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutGap="10px">
            <mat-form-field fxFlex="25">
                <input type="text" placeholder="{{
                    translatePrefix + 'naseljenoMesto' | translate
                  }}" matInput formControlName="naseljenoMesto" [matAutocomplete]="autoMesto" (keyup)="_filterMesta()">
                <mat-autocomplete #autoMesto="matAutocomplete">
                    <mat-option *ngFor="let mesto of filtriranaMesta" [value]="mesto.nazivCirilica"
                        (click)="setMesto(mesto)" class="autocomplete-mat-opetion">
                        {{mesto.nazivCirilica}}
                    </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="naseljenoMesto.invalid" class="alert">
                    <span *ngIf="naseljenoMesto.errors['required']">
                        {{translatePrefix + "obaveznoPolje"| translate: {
                        attributName: translatePrefix + "naseljenoMesto" | translate} }}
                    </span>
                    <span *ngIf="naseljenoMesto.errors['invalidAutocompleteValue']">
                        {{translatePrefix + "nijeIzabranoMesto" | translate}}
                    </span>
                </mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="25">
                <input type="text" placeholder="{{
                    translatePrefix + 'ulica' | translate
                  }}" matInput formControlName="ulica" [matAutocomplete]="autoUlica" (keyup)="_filterUlice()">
                <mat-autocomplete #autoUlica="matAutocomplete">
                    <mat-option *ngFor="let ulica of filtriraneUlice" [value]="ulica.nazivCirilica"
                        (click)="setUlicu(ulica)" class="autocomplete-mat-opetion">
                        {{ulica.nazivCirilica}}
                    </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="ulica.invalid" class="alert">
                    <span *ngIf="ulica.errors['required']">
                        {{translatePrefix + "obaveznoPolje"| translate: {
                        attributName: translatePrefix + "ulica" | translate} }}
                    </span>
                    <span *ngIf="ulica.errors['invalidAutocompleteValue']">
                        {{translatePrefix + "nijeIzabranaUlica" | translate}}
                    </span>
                </mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="50">
                <input matInput type="text" formControlName="ulicaVanSifarnika" placeholder="{{
              translatePrefix + 'ulicaVanSifarnika' | translate
            }}" (input)="postaviUlicuVanSifarnikaUTekstualnuAdresu()" />
                <mat-error *ngIf="ulicaVanSifarnika.invalid" class="alert">
                    <span *ngIf="ulicaVanSifarnika.errors['required']">
                        {{translatePrefix + "obaveznoPolje"| translate: {
                        attributName: translatePrefix + "ulicaVanSifarnika" | translate} }}
                    </span>
                </mat-error>
            </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
            <mat-form-field fxFlex="50">
                <input type="text" placeholder="{{
                    translatePrefix + 'kucniBroj' | translate
                  }}" matInput formControlName="kucniBroj" [matAutocomplete]="autoBroj"
                    (keyup)="_filterKucneBrojeve()">
                <mat-autocomplete #autoBroj="matAutocomplete">
                    <mat-option *ngFor="let broj of filtriraniKucniBrojevi" [value]="broj.broj"
                        (click)="setKucniBroj(broj)" class="autocomplete-mat-opetion">
                        {{broj.broj}}
                    </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="kucniBroj.invalid" class="alert">
                    <span *ngIf="kucniBroj.errors['required']">
                        {{translatePrefix + "obaveznoPolje" | translate: {
                        attributName: translatePrefix + "kucniBroj" | translate } }}
                    </span>
                    <span *ngIf="kucniBroj.errors['invalidAutocompleteValue']">
                        {{translatePrefix + "nijeIzabranKucniBroj" | translate}}
                    </span>
                </mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="50">
                <input matInput type="text" formControlName="kucniBrojVanSifarnika" placeholder="{{
            translatePrefix + 'kucniBrojVanSifarnika' | translate
          }}" (input)="postaviKucniBrojVanSifarnikaUTekstualnuAdresu()" />
                <mat-error *ngIf="kucniBrojVanSifarnika.invalid" class="alert">
                    <span *ngIf="kucniBrojVanSifarnika.errors['required']">
                        {{translatePrefix + "obaveznoPolje" |translate : {
                        attributName: translatePrefix + "kucniBrojVanSifarnika" | translate } }}
                    </span>
                </mat-error>
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
            <mat-form-field fxFlex="20">
                <input matInput type="text" formControlName="dodatak"
                    placeholder="{{ translatePrefix + 'dodatak' | translate }}" />
                <mat-error *ngIf="dodatak.invalid" class="alert">
                    <span *ngIf="dodatak.errors['required']">
                        {{translatePrefix + "obaveznoPolje" | translate:
                        {attributName: translatePrefix + "dodatak" | translate } }}
                    </span>
                </mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="20">
                <input matInput type="text" formControlName="ulaz"
                    placeholder="{{ translatePrefix + 'ulaz' | translate }}" />
                <mat-error *ngIf="ulaz.invalid" class="alert">
                    <span *ngIf="ulaz.errors['required']">
                        {{translatePrefix + "obaveznoPolje" | translate: {
                        attributName: translatePrefix + "ulaz" | translate } }}
                    </span>
                </mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="20">
                <input matInput type="text" formControlName="sprat"
                    placeholder="{{ translatePrefix + 'sprat' | translate }}" />
                <mat-error *ngIf="sprat.invalid" class="alert">
                    <span *ngIf="sprat.errors['required']">
                        {{translatePrefix + "obaveznoPolje" | translate
                        : {attributName: translatePrefix + "sprat" | translate } }}
                    </span>
                </mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="20">
                <input matInput type="text" formControlName="stan"
                    placeholder="{{ translatePrefix + 'stan' | translate }}" />
                <mat-error *ngIf="stan.invalid" class="alert">
                    <span *ngIf="stan.errors['required']">
                        {{translatePrefix + "obaveznoPolje" | translate: {
                        attributName: translatePrefix + "stan" | translate } }}
                    </span>
                </mat-error>
            </mat-form-field>
        </div>
    </form>
</div>